import { GetRecipeDiscussionByEmailMeta, GetRecipeDiscussionByEmailPayload } from 'types/store/GetRecipeDiscussionByEmail';
import { createAsyncAction } from 'utils/Redux';

const ns = 'GET_RECIPE_DISCUSSION_BY_EMAIL_NS';

const asyncAction = createAsyncAction<GetRecipeDiscussionByEmailMeta, GetRecipeDiscussionByEmailPayload>(ns);

const getRecipeDiscussionByEmailActions = { ...asyncAction };

export default getRecipeDiscussionByEmailActions;
